import { insert, remove, findIndex } from 'ramda';
import uniqid from 'uniqid';

import {
    LOCATION_CHANGE,

    CLOSE_ALL_COLLAPSIBLE,
    SET_COLLAPSIBLE_ACTIVE,
    COLLAPSE_MODALS,
    CLOSE_COLLAPSIBLE,
    REMOVE_ALL_COLLAPSIBLE,
    SHOW_COLLAPSIBLE,

    OPEN_MODAL_EVENT,
    OPEN_MODAL_DOCUMENT_VIEW,
    OPEN_MODAL_PERSON,
    OPEN_MODAL_PROJECT,
    OPEN_MODAL_COMPANY
} from 'constants/actionTypes';

const initialState = {
    active: null,
    collapsed: true,
    modals: []
};

export const collapsibleModalsReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_MODAL_COMPANY:
        case OPEN_MODAL_DOCUMENT_VIEW:
        case OPEN_MODAL_EVENT:
        case OPEN_MODAL_PERSON:
        case OPEN_MODAL_PROJECT:
            var existedIndex = findIndex(modal => modal.params.id === action.payload.id, state.modals);
            var existed = existedIndex > -1;
            var active = existed ? existedIndex : state.collapsed ? state.modals.length : state.active + 1;

            return {
                active,
                collapsed: false,
                modals: existed ?
                    state.modals :
                    insert(active, {
                        id: uniqid(),
                        type: action.type,
                        params: action.payload
                    }, state.modals),
            };
        case SHOW_COLLAPSIBLE:
            return {
                ...state,
                collapsed: false
            };
        case SET_COLLAPSIBLE_ACTIVE:
            return {
                ...state,
                collapsed: false,
                active: action.payload
            };
        case LOCATION_CHANGE:
        case COLLAPSE_MODALS:
            return {
                ...state,
                collapsed: true
            };
        case CLOSE_COLLAPSIBLE:
            var modals = remove(action.payload, 1, state.modals);

            return {
                modals,
                collapsed: !modals.length,
                active: !modals.length ? null : modals.length === state.active ? state.active - 1 : state.active
            };
        case CLOSE_ALL_COLLAPSIBLE:
            return {
                ...state,
                collapsed: true
            };
        case REMOVE_ALL_COLLAPSIBLE:
            return initialState;
        default:
            return state;
    }
};
